import {
  FAILURE_CREATE_SEGMENT_GROUP,
  FAILURE_FETCH_SEGMENT_GROUPS,
  FAILURE_INACTIVATE_SEGMENT_GROUP,
  FAILURE_SORT_SEGMENT_GROUP,
  FAILURE_UPDATE_SEGMENT_GROUP,
  REQUEST_CREATE_SEGMENT_GROUP,
  REQUEST_FETCH_SEGMENT_GROUPS,
  REQUEST_INACTIVATE_SEGMENT_GROUP,
  REQUEST_SORT_SEGMENT_GROUP,
  REQUEST_UPDATE_SEGMENT_GROUP,
  RESET_SEGMENT_GROUPS_STATE,
  SET_ACTIVE_SEGMENT,
  SUCCESS_CREATE_SEGMENT_GROUP,
  SUCCESS_FETCH_SEGMENT_GROUPS,
  SUCCESS_INACTIVATE_SEGMENT_GROUP,
  SUCCESS_SORT_SEGMENT_GROUP,
  SUCCESS_UPDATE_SEGMENT_GROUP,
} from 'actions/actionTypes';
import { SegmentType } from 'constants/segments';
import {
  SegmentGroupInputTypes,
  SegmentGroupSortParamsTypes,
  SegmentGroupTypes,
  SegmentGroupUpdateTypes,
} from 'types/backend/segment';

export const requestFetchSegmentGroups = () => ({
  type: REQUEST_FETCH_SEGMENT_GROUPS,
});

export const successFetchSegmentGroups = (payload: SegmentGroupTypes[]) => ({
  type: SUCCESS_FETCH_SEGMENT_GROUPS,
  payload,
});

export const failureFetchSegmentGroups = () => ({
  type: FAILURE_FETCH_SEGMENT_GROUPS,
});

export const setActiveSegment = (segmentType: SegmentType) => ({
  type: SET_ACTIVE_SEGMENT,
  segmentType,
});

export const requestCreateSegmentGroup = (params: SegmentGroupInputTypes) => ({
  type: REQUEST_CREATE_SEGMENT_GROUP,
  params,
});

export const successCreateSegmentGroup = (payload: SegmentGroupTypes) => ({
  type: SUCCESS_CREATE_SEGMENT_GROUP,
  payload,
});

export const failureCreateSegmentGroup = () => ({
  type: FAILURE_CREATE_SEGMENT_GROUP,
});

export const requestUpdateSegmentGroup = (params: SegmentGroupUpdateTypes) => ({
  type: REQUEST_UPDATE_SEGMENT_GROUP,
  params,
});

export const successUpdateSegmentGroup = (payload: SegmentGroupTypes) => ({
  type: SUCCESS_UPDATE_SEGMENT_GROUP,
  payload,
});

export const failureUpdateSegmentGroup = () => ({
  type: FAILURE_UPDATE_SEGMENT_GROUP,
});

export const requestInactivateSegmentGroup = (segmentGroupId: string) => ({
  type: REQUEST_INACTIVATE_SEGMENT_GROUP,
  segmentGroupId,
});

export const successInactivateSegmentGroup = (payload: SegmentGroupTypes) => ({
  type: SUCCESS_INACTIVATE_SEGMENT_GROUP,
  payload,
});

export const failureInactivateSegmentGroup = () => ({
  type: FAILURE_INACTIVATE_SEGMENT_GROUP,
});

export const requestSortSegmentGroup = (params: SegmentGroupSortParamsTypes) => ({
  type: REQUEST_SORT_SEGMENT_GROUP,
  params,
});

export const successSortSegmentGroup = (payload: SegmentGroupTypes[]) => ({
  type: SUCCESS_SORT_SEGMENT_GROUP,
  payload,
});

export const failureSortSegmentGroup = () => ({
  type: FAILURE_SORT_SEGMENT_GROUP,
});

export const resetSegmentGroupsState = () => ({
  type: RESET_SEGMENT_GROUPS_STATE,
});
